import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

/** ========= MOCK opcional =========
 * Ative com: REACT_APP_MOCK_CMS=1
 */
const delay = (ms = 220) => new Promise((r) => setTimeout(r, ms));
const isMock = typeof process !== "undefined" && process.env?.REACT_APP_MOCK_CMS === "1";

let MOCK_DB = [
  // Páginas operacionais (longas)
  {
    id: 1,
    tipo: "como_comprar",
    titulo: "Como comprar",
    slug: "como-comprar",
    conteudo: "## 1. Passo a passo\nConteúdo exemplo...",
    ordem: 1,
    status: 1,
    updated_at: "2025-08-01",
    auto_toc: true,
  },
  {
    id: 2,
    tipo: "pagamento",
    titulo: "Pagamento",
    slug: "pagamento",
    conteudo: "## Meios de pagamento\nPIX, Cartão, Boleto...",
    ordem: 2,
    status: 1,
    updated_at: "2025-08-12",
    auto_toc: true,
  },
  {
    id: 3,
    tipo: "entregas",
    titulo: "Entregas e prazos",
    slug: "entregas",
    conteudo: "## Prazo de envio\nInformações gerais...",
    ordem: 3,
    status: 1,
    updated_at: "2025-08-10",
    auto_toc: true,
  },
  {
    id: 4,
    tipo: "trocas",
    titulo: "Trocas e devoluções",
    slug: "trocas",
    conteudo: "## Condições\nDetalhes para trocas...",
    ordem: 4,
    status: 1,
    updated_at: "2025-08-05",
    auto_toc: true,
  },

  // FAQ (agrupado)
  {
    id: 5,
    tipo: "faq",
    titulo: "Perguntas frequentes (FAQ)",
    slug: "faq",
    ordem: 5,
    status: 1,
    updated_at: "2025-08-03",
    auto_toc: false,
    faq_groups: [
      {
        titulo: "Pedidos",
        items: [
          { pergunta: "Como faço um pedido?", resposta: "Adicione ao carrinho e finalize." },
          { pergunta: "Posso alterar meu pedido?", resposta: "Entre em contato até o envio." },
        ],
      },
      {
        titulo: "Pagamento",
        items: [{ pergunta: "Há parcelamento?", resposta: "Sim, conforme condições do site." }],
      },
    ],
  },

  // Políticas (longas)
  {
    id: 6,
    tipo: "privacidade",
    titulo: "Declaração de Privacidade",
    slug: "declaracao-de-privacidade",
    conteudo: "## Coleta de dados\nTexto exemplo...",
    ordem: 10,
    status: 1,
    updated_at: "2025-07-28",
    auto_toc: true,
  },
  {
    id: 7,
    tipo: "cookies",
    titulo: "Política de Cookies",
    slug: "cookies",
    conteudo: "## O que são cookies?\nTexto exemplo...",
    ordem: 11,
    status: 1,
    updated_at: "2025-07-20",
    auto_toc: true,
  },
  {
    id: 8,
    tipo: "termos",
    titulo: "Termos de uso",
    slug: "terms",
    conteudo: "## Termos\nTexto exemplo...",
    ordem: 12,
    status: 1,
    updated_at: "2025-07-15",
    auto_toc: true,
  },
  {
    id: 9,
    tipo: "lgpd",
    titulo: "LGPD",
    slug: "lgpd",
    conteudo: "## Direitos do titular\nTexto exemplo...",
    ordem: 13,
    status: 1,
    updated_at: "2025-07-12",
    auto_toc: true,
  },

  // Links do rodapé
  {
    id: 10,
    tipo: "links_rodape",
    titulo: "Links do rodapé",
    slug: "links-rodape",
    links: [
      { rotulo: "Privacidade", href: "/declaracao-de-privacidade", target: "_self" },
      { rotulo: "Cookies", href: "/cookies", target: "_self" },
    ],
    ordem: 20,
    status: 1,
    updated_at: "2025-08-02",
    auto_toc: false,
  },

  // Listas simples
  {
    id: 11,
    tipo: "sugestoes_busca",
    titulo: "Sugestões de busca",
    slug: "sugestoes-busca",
    lista: ["filtro", "óleo", "kit"],
    ordem: 21,
    status: 1,
    updated_at: "2025-08-08",
    auto_toc: false,
  },
  {
    id: 12,
    tipo: "segmentos",
    titulo: "Segmentos",
    slug: "segmentos",
    lista: ["Ônibus", "Caminhão", "Vans"],
    ordem: 22,
    status: 1,
    updated_at: "2025-08-09",
    auto_toc: false,
  },
  {
    id: 13,
    tipo: "treinamento_plataforma",
    titulo: "Onboarding (mock)",
    slug: "onboarding-mock",
    ordem: 3,
    status: 1,
    updated_at: "2026-03-01",
    auto_toc: false,
    conteudo_json: {
      format: "training_kb.v1",
      intro: "Treinamento de exemplo para desenvolvimento local.",
      modules: [
        {
          id: "mod-m1",
          title: "Primeiros passos",
          order: 0,
          items: [
            {
              id: "it-m1",
              kind: "link",
              title: "Site Xpro",
              url: "https://xpro.me",
              notes: "Portal oficial.",
              order: 0,
            },
          ],
        },
      ],
    },
  },
  {
    id: 14,
    tipo: "treinamento_plataforma",
    titulo: "Atendimento (mock)",
    slug: "atendimento-mock",
    ordem: 4,
    status: 1,
    updated_at: "2026-03-02",
    auto_toc: false,
    conteudo_json: {
      format: "training_kb.v1",
      intro: "Segundo treinamento para testar lista.",
      modules: [
        {
          id: "mod-m2",
          title: "Chat",
          order: 0,
          items: [
            {
              id: "it-m2",
              kind: "video",
              title: "Vídeo exemplo",
              url: "https://www.w3schools.com/html/mov_bbb.mp4",
              notes: "Use notas para a IA quando não houver PDF.",
              order: 0,
            },
          ],
        },
      ],
    },
  },
];

const mockFetch = async (url, method = "GET", body) => {
  await delay();
  const q = Object.fromEntries(new URLSearchParams(url.split("?")[1] || ""));
  if (method === "GET") {
    const page = Math.max(1, Number(q.page) || 1);
    const limit = Math.max(1, Number(q.limit) || 50);
    const search = (q.search || "").toLowerCase();

    let list = MOCK_DB.slice();
    if (search) {
      list = list.filter((c) =>
        [c.titulo, c.slug, c.tipo].filter(Boolean).some((t) => String(t).toLowerCase().includes(search))
      );
    }
    list.sort(
      (a, b) =>
        (a.ordem || 0) - (b.ordem || 0) ||
        String(a.titulo).localeCompare(String(b.titulo))
    );
    const start = (page - 1) * limit;
    return { data: list.slice(start, start + limit), pagination: { total: list.length, page, limit } };
  }
  if (method === "POST") {
    const nextId = MOCK_DB.length ? Math.max(...MOCK_DB.map((x) => x.id)) + 1 : 1;
    const created = { id: nextId, ...body };
    MOCK_DB.push(created);
    return { data: created };
  }
  if (method === "PUT") {
    const id = Number(url.split("/")[2]);
    const i = MOCK_DB.findIndex((x) => x.id === id);
    if (i >= 0) MOCK_DB[i] = { ...MOCK_DB[i], ...body };
    return { data: MOCK_DB[i] };
  }
  if (method === "DELETE") {
    const id = Number(url.split("/")[2]);
    MOCK_DB = MOCK_DB.filter((x) => x.id !== id);
    return { data: { success: true } };
  }
  throw new Error("mock: método não suportado");
};

const doFetch = (url, method = "GET", body) =>
  isMock ? mockFetch(url, method, body) : fetchData(url, method, body);
/** ========= /MOCK ========= */

export const useContents = (page = 1, limit = 50, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["contents", page, limit, search],
    () => doFetch(`/contents?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (res) => ({ contents: res?.data || [], pagination: res?.pagination || { total: 0 } }),
    }
  );

  const updateMutation = useMutation(
    (content) => {
      const method = content.id ? "PUT" : "POST";
      const endpoint = content.id ? `/contents/${content.id}` : `/contents`;
      return doFetch(endpoint, method, content);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("contents");
        queryClient.invalidateQueries("trainingHub");
      },
    }
  );

  const deleteMutation = useMutation(
    (id) => doFetch(`/contents/${id}`, "DELETE"),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("contents");
        queryClient.invalidateQueries("trainingHub");
      },
    }
  );

  return { ...query, updateMutation, deleteMutation };
};
